module.exports = __webpack_public_path__ + "static/media/pharma4.372a4b4f.jpg";